module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Status Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Status Description",
      "rules": _vm.nameRules,
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.statusDescription),
      callback: function($$v) {
        _vm.statusDescription = $$v
      },
      expression: "statusDescription"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Triggers Notifications"
    },
    model: {
      value: (_vm.triggersNotification),
      callback: function($$v) {
        _vm.triggersNotification = $$v
      },
      expression: "triggersNotification"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Data Captured"
    },
    model: {
      value: (_vm.dataCaptured),
      callback: function($$v) {
        _vm.dataCaptured = $$v
      },
      expression: "dataCaptured"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Get Approval"
    },
    model: {
      value: (_vm.getApproval),
      callback: function($$v) {
        _vm.getApproval = $$v
      },
      expression: "getApproval"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Approved"
    },
    model: {
      value: (_vm.approved),
      callback: function($$v) {
        _vm.approved = $$v
      },
      expression: "approved"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Denied"
    },
    model: {
      value: (_vm.cancel),
      callback: function($$v) {
        _vm.cancel = $$v
      },
      expression: "cancel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Reviewed"
    },
    model: {
      value: (_vm.reviewed),
      callback: function($$v) {
        _vm.reviewed = $$v
      },
      expression: "reviewed"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "SR Collection"
    },
    model: {
      value: (_vm.srCollection),
      callback: function($$v) {
        _vm.srCollection = $$v
      },
      expression: "srCollection"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "More Info"
    },
    model: {
      value: (_vm.moreInfo),
      callback: function($$v) {
        _vm.moreInfo = $$v
      },
      expression: "moreInfo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "SR - Received DDC"
    },
    model: {
      value: (_vm.receivedDdc),
      callback: function($$v) {
        _vm.receivedDdc = $$v
      },
      expression: "receivedDdc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "SR - Raised"
    },
    model: {
      value: (_vm.raised),
      callback: function($$v) {
        _vm.raised = $$v
      },
      expression: "raised"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "SR - Cancelled"
    },
    model: {
      value: (_vm.cancelled),
      callback: function($$v) {
        _vm.cancelled = $$v
      },
      expression: "cancelled"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "SR - Receipted"
    },
    model: {
      value: (_vm.receipted),
      callback: function($$v) {
        _vm.receipted = $$v
      },
      expression: "receipted"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.isAddValid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddStatus()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}